module.exports = __webpack_public_path__ + "img/2.a0200e28.jpg";